module.exports = __webpack_public_path__ + "img/logo-white.c9fef8d9.png";